module.exports = __webpack_public_path__ + "media/images/partners/necs-648ecda5c342897e0e743e133b2aec76.jpeg";